const linderos = [
  { id: "I", text: "Los modos de reconocimiento." },
  { id: "II", text: "La división de la masonería simbólica en tres grados." },
  { id: "III", text: "La leyenda del tercer grado." },
  { id: "IV", text: "El gobierno de la fraternidad por un Gran Maestro." },
  { id: "V", text: "La prerrogativa del Gran Maestro de presidir la Gran Logia y toda Logia de su jurisdicción." },
  { id: "VI", text: "La prerrogativa del Gran Maestro de dar dispensa con el objeto de conferir grados fuera de la época reglamentaria." },
  { id: "VII", text: "La prerrogativa del Gran Maestro de conceder dispensa para organización de Logias." },
  { id: "VIII", text: "La prerrogativa del Gran Maestro de hacer masones a la vista." },
  { id: "IX", text: "El imperativo de que los masones se reúnan en Logias." },
  { id: "X", text: "El gobierno de las Logias por un Venerable Maestro y dos Vigilantes." },
  { id: "XI", text: "La necesidad de que toda Logia, cuando reunida esté a cubierto." },
  { id: "XII", text: "El derecho de todo Masón y de toda Logia de estar representados en la Gran Logia." },
  { id: "XIII", text: "El derecho de todo Masón de apelar ante la Gran Logia de las decisiones de su Logia." },
  { id: "XIV", text: "El derecho de todo masón regular y activo para visitar." },
  { id: "XV", text: "El deber de examinar a todo visitador antes de permitir la entrada a la Logia." },
  { id: "XVI", text: "La prohibición de una Logia para intervenir en los asuntos de otra." },
  { id: "XVII", text: "La obligación de todo masón de estar sujeto a las leyes y Reglamentos de la Gran Logia de su Jurisdicción." },
  { id: "XVIII", text: "La posesión de ciertas indispensables cualidades por los candidatos a la Iniciación." },
  { id: "XIX", text: "La creencia en la existencia de un Ser Supremo, como el G.·.A.·.D.·.U.·." },
  { id: "XX", text: "La creencia en la inmortalidad del alma." },
  { id: "XXI", text: "La necesidad de que un LIBRO DE LA LEY sea indispensable en cada Logia, como que contiene la voluntad revelada del G.·.A.·.D.·.U.·." },
  { id: "XXII", text: "La igualdad de todos los masones como hijos del Gran Padre de la humanidad; en amor, protección y armonía." },
  { id: "XXIII", text: "El secreto de la institución." },
  { id: "XXIV", text: "La fundación de una ciencia especulativa sobre un arte operativo." },
  { id: "XXV", text: "Que estos LINDEROS, no pueden ser jamás alterados." }
];

const AntiguosLinderos = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-12 md:pt-40 md:pb-16 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('/antiguoslinderos.jpg')" }} // Imagen local desde public
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Nosotros
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            Antiguos Linderos
          </h1>
          <p className="text-gray-400 font-light text-sm md:text-base max-w-2xl mx-auto animate-fade-in [animation-delay:0.6s]">
            Los Antiguos Linderos Inmutables de la Francmasonería o Landmark
          </p>
        </div>
      </section>

      {/* Introducción / Contexto */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 pt-16">
        <div className="bg-[#0a0a0a] border-l-4 border-[#C5A059] p-6 md:p-10 max-w-4xl mx-auto shadow-2xl">
          <p className="text-gray-300 font-light leading-relaxed text-center md:text-lg">
            Adoptados el 25 de Marzo de 1882 al constituirse la 
            <span className="block text-white font-serif mt-2">Gran Logia de los AA.·. LL.·. y AA.·. Masones de la República del Perú</span>
          </p>
          <p className="text-[#C5A059] text-xs tracking-widest uppercase text-center mt-4">
            (Páginas 5 y 6 de la Constitución de la Gran Logia del Perú)
          </p>
        </div>
      </section>

      {/* Grilla de los 25 Linderos */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-8">
          {linderos.map((lindero, index) => (
            <div 
              key={index} 
              className="group bg-[#0a0a0a] border border-white/5 p-8 hover:border-[#C5A059]/40 transition-colors duration-500 flex flex-col"
            >
              <div className="flex items-center gap-4 mb-4">
                <span className="text-[#C5A059] font-serif text-3xl font-light">
                  {lindero.id}.
                </span>
                <div className="h-[1px] flex-grow bg-white/5 group-hover:bg-[#C5A059]/20 transition-colors duration-500"></div>
              </div>
              <p className="text-gray-300 font-light leading-relaxed text-sm md:text-base flex-grow">
                {lindero.text}
              </p>
            </div>
          ))}
        </div>

        {/* Footer del documento */}
        <div className="mt-20 border-t border-white/10 pt-8 flex flex-col items-center justify-center text-center">
          <p className="text-gray-500 text-xs tracking-widest uppercase">
            Actualizado al 30/09/2025
          </p>
        </div>
      </section>

    </div>
  );
};

export default AntiguosLinderos;